import { render, staticRenderFns } from "./invitation-form.vue?vue&type=template&id=2a6ecfde"
import script from "./invitation-form.vue?vue&type=script&lang=js"
export * from "./invitation-form.vue?vue&type=script&lang=js"
import style0 from "./invitation-form.vue?vue&type=style&index=0&id=2a6ecfde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports